$('.product-single__photos').flickity({
  pageDots: false,
  prevNextButtons: false
});
// 2nd carousel, navigation
$('.product-single__thumbnails').flickity({
  asNavFor: '.product-single__photos',
  contain: true,
  pageDots: false,
  prevNextButtons: false
});
